export const MINIMUM_MINUTES_PICKABLE: number = 5 as const;
